import { authHeader } from "../../../../../helpers/auth-header";
import { client } from "../../../../../actions";
import { message } from "antd";
import uri from "../../../constants/uri";

const deleteAnswerFile = async (attachId, itemId) => {
	try {
		await client.delete(`${uri}/item_attachment`, {
			params: {
				attachId,
				itemId,
			},
			headers: authHeader(),
		});
	} catch (e) {
		console.error(e);
		message.error(
			"Не получилось удалить вложение варианта ответа, попробуйте позже"
		);
	}
};

export default deleteAnswerFile;
